const phoneNumberRegEx =
  /^(((\+44\s?\d{4}|\(?0\d{4}\)?)\s?\d{3}\s?\d{3})|((\+44\s?\d{3}|\(?0\d{3}\)?)\s?\d{3}\s?\d{4})|((\+441\s?\d{3}|\(?01\d{3}\)?)\s?\d{5})|((\+44\s?\d{2}|\(?0\d{2}\)?)\s?\d{4}\s?\d{4}))(\s?(\d{4}|\d{3}))?$/;
const invalidCharacters = /[^0-9+]+/g;

export const sanitisePhoneNum = (input: string) => {
  const sanitisedInput = String(input).replace(invalidCharacters, '');

  return sanitisedInput;
};

export const isValidPhoneNum = (input: string) => {
  const sanitisedInput = sanitisePhoneNum(input);
  if (sanitisedInput.length >= 10) {
    return phoneNumberRegEx.test(sanitisedInput);
  }
  return false;
};
